import * as Scrivito from "scrivito";
import LinksListSecondLevel from "./LinksListSecondLevel";
import BackLink from "./BackLink";

function SecondLevel({ elems, currentPage }) {
  return (
    <div>
      <BackLink
        containerClassNames="hadow bg-white"
        linkClassNames="text-dark font-weight-normal p-3 btn btn-link"
      />
      <div className="bg-secondary">
        <LinksListSecondLevel elems={elems} currentPage={currentPage} />
      </div>
    </div>
  );
}

export default Scrivito.connect(SecondLevel);
